document.addEventListener('DOMContentLoaded', () => {
    const createMobileLayout = () => {
        if (window.innerWidth >= 768) return;

        const menuContainer = document.querySelector('.sub-navigation-menu');
        const menuItems = Array.from(document.querySelectorAll('.sub-navigation-menu-item'));
        const currentPage = document.querySelector('.sub-navigation-menu-item.current-page-item') ?? menuItems[0];

        if (menuItems.length > 0 && currentPage) {
            if (menuContainer.firstElementChild !== currentPage) {
                menuContainer.prepend(currentPage);
            }

            currentPage.classList.add('show');

            currentPage.addEventListener('click', () => {
                const isOpen = menuItems.filter(item => item.classList.contains('show')).length > 1;

                menuItems.forEach((item) => {
                    if (item !== currentPage) {
                        item.classList.toggle('show');
                    }
                });

                const isNowOpen = menuItems.filter(item => item.classList.contains('show')).length > 1;
                if (isNowOpen) {
                    menuContainer.classList.add('menu-open');
                } else {
                    menuContainer.classList.remove('menu-open');
                }
            });
        }
    };

    createMobileLayout();

    window.addEventListener('resize', () => {
        if (window.innerWidth < 768) {
            createMobileLayout();
        }
    });
});
